import React from "react";
import { Routes, Route, useLocation, matchPath } from "react-router-dom";
import Sidebar from "../shared/components/Sidebar";
import RegisterPage from "../features/auth/components/RegisterPage";
import LoginPage from "../features/auth/components/LoginPage";
import Admin from "../features/dashboard/components/Admin";
import Post from "../features/posts/components/Post";
import PostDetails from "../features/posts/components/PostDetails";
import UserDetailsPage from "../features/users/components/UserDetailsPage";
import Donation from "../features/donations/components/Donation";
import Bio from "../features/biodata/components/Biodata";
import BiodataDetails from "../features/biodata/components/BiodataDetails";
import AddBiodata from "../features/biodata/components/AddBiodata";
import EditBiodata from "../features/biodata/components/EditBiodata";
import Jobs from "../features/jobs/components/Jobs";
import AddJob from "../features/jobs/components/AddJobWithCloudinary";
import AddUser from "../features/users/components/AddUser";
import AddPost from "../features/posts/components/AddPost";
import EditPost from "../features/posts/components/EditPost";
import QuickReadsCategory from "../features/jobs/components/QuickReadsCategory";
import ImprovedUserList from "../features/chats/components/ImprovedUserList";
import CommentsPage from "../features/posts/components/CommentsPage";
import JobDetails from "../features/jobs/components/Jobdetail";
import ChatPage from "../features/chats/components/ChatPage";
import MassMessage from "../features/dashboard/components/MassMessage";
import Articles from "../features/articles/components/Articles";
import AddArticle from "../features/articles/components/AddArticleWithCloudinary";
import EditArticle from "../features/articles/components/EditArticle";
import ArticleDetails from "../features/articles/components/ArticleDetails";
import ManageHashtags from "../features/posts/components/ManageHashtags";
import Settings from "../features/settings/components/Settings";
import NotFoundPage from "../shared/components/NotFoundPage";
import ProtectedRoute from "../shared/components/ProtectedRoute";

const P = ({ children }: { children: React.ReactNode }) => (
  <ProtectedRoute>{children}</ProtectedRoute>
);

function AppRoutes() {
  const location = useLocation();

  const sidebarRoutePatterns = [
    "/admin",
    "/post",
    "/post/:postId",
    "/addpost",
    "/edit-post/:postId",
    "/jobs",
    "/jobs/:id",
    "/add-job",
    "/QuickReadsCategory",
    "/user/:id",
    "/add-user",
    "/donation",
    "/bio",
    "/biodata",
    "/biodata/:id",
    "/add-biodata",
    "/edit-biodata/:id",
    "/improved-chat",
    "/chat/:userId",
    "/mass-messaging",
    "/articles",
    "/add-article",
    "/edit-article/:id",
    "/articles/:id",
    "/comments/:postId",
    "/manage-hashtags",
    "/settings",
  ];

  const isSidebarVisible = sidebarRoutePatterns.some((pattern) =>
    Boolean(matchPath({ path: pattern, end: true }, location.pathname))
  );

  return (
    <div className="flex h-screen overflow-hidden">
      {isSidebarVisible && <Sidebar />}
      <div
        className={`flex-1 overflow-y-auto transition-margin duration-300 ${
          isSidebarVisible ? "lg:ml-64" : "ml-0"
        }`}
      >
        <Routes>
          <Route path="/" element={<LoginPage />} />
          <Route path="/register" element={<RegisterPage />} />
          <Route path="/admin" element={<P><Admin /></P>} />
          <Route path="/post" element={<P><Post /></P>} />
          <Route path="/post/:postId" element={<P><PostDetails /></P>} />
          <Route path="/addpost" element={<P><AddPost /></P>} />
          <Route path="/edit-post/:postId" element={<P><EditPost /></P>} />
          <Route path="/jobs" element={<P><Jobs /></P>} />
          <Route path="/jobs/:id" element={<P><JobDetails /></P>} />
          <Route path="/add-job" element={<P><AddJob /></P>} />
          <Route path="/QuickReadsCategory" element={<P><QuickReadsCategory /></P>} />
          <Route path="/user/:id" element={<P><UserDetailsPage /></P>} />
          <Route path="/add-user" element={<P><AddUser /></P>} />
          <Route path="/donation" element={<P><Donation /></P>} />
          <Route path="/bio" element={<P><Bio /></P>} />
          <Route path="/biodata" element={<P><Bio /></P>} />
          <Route path="/biodata/:id" element={<P><BiodataDetails /></P>} />
          <Route path="/add-biodata" element={<P><AddBiodata /></P>} />
          <Route path="/edit-biodata/:id" element={<P><EditBiodata /></P>} />
          <Route path="/improved-chat" element={<P><ImprovedUserList /></P>} />
          <Route path="/chat/:userId" element={<P><ChatPage /></P>} />
          <Route path="/mass-messaging" element={<P><MassMessage /></P>} />
          <Route path="/articles" element={<P><Articles /></P>} />
          <Route path="/add-article" element={<P><AddArticle /></P>} />
          <Route path="/edit-article/:id" element={<P><EditArticle /></P>} />
          <Route path="/articles/:id" element={<P><ArticleDetails /></P>} />
          <Route path="/comments/:postId" element={<P><CommentsPage /></P>} />
          <Route path="/manage-hashtags" element={<P><ManageHashtags /></P>} />
          <Route path="/settings" element={<P><Settings /></P>} />
          <Route path="*" element={<NotFoundPage />} />
        </Routes>
      </div>
    </div>
  );
}

export default AppRoutes;
